import React from 'react';
import { PlanetSportMainLogoWrapper, PlanetSportMainLogo } from './planetsportbet.style';

export const PlanetSportLogotype = (): JSX.Element => (
    <PlanetSportMainLogoWrapper>
        <PlanetSportMainLogo />
    </PlanetSportMainLogoWrapper>
);
